import { GroupBox } from '../GroupBox/GroupBox.mjs';

const Fieldset = GroupBox;

export { Fieldset };
